export default function ownerDocument(node) {
  return node && node.ownerDocument || document;
}


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/ownerDocument/ownerDocument.js
// module id = 1599
// module chunks = 22